module.exports = __webpack_public_path__ + "img/gotta-catch.d2dfd80e.png";